import { render, staticRenderFns } from "./BtnLoader.vue?vue&type=template&id=29433060"
import script from "./BtnLoader.vue?vue&type=script&lang=js"
export * from "./BtnLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports